import {Box, Button, Divider, Paper, TextField, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {getCompanyProducts, saveCompanyProducts} from "../../../services/CompanyService";
import {useMessageContext} from "../../../contexts/MessageContext";
import SaveIcon from '@mui/icons-material/Save';

const CompanyProductTab = ({company, setLoader}) => {

  const {notificationHandler} = useMessageContext();

  const [companyProducts, setCompanyProducts] = useState();

  const [reload, setReload] = useState(false);

  useEffect(() => {
    setLoader(true);
    getCompanyProducts(company.id)
        .then(res => {
          setCompanyProducts(res.data);
        }).then(() => setLoader(false))
  }, [reload, company.id, setLoader]);

  const updateCustomField1 = (customField1) => {
    setCompanyProducts(prv => {
      return {...prv, customField1}
    })
  }

  const updateCustomField2 = (customField2) => {
    setCompanyProducts(prv => {
      return {...prv, customField2}
    })
  }

  const updateCustomField3 = (customField3) => {
    setCompanyProducts(prv => {
      return {...prv, customField3}
    })
  }

  const updateProductOffering1 = (productOffering1) => {
    setCompanyProducts(prv => {
      return {...prv, productOffering1}
    })
  }

  const updateProductOffering2 = (productOffering2) => {
    setCompanyProducts(prv => {
      return {...prv, productOffering2}
    })
  }

  const updateProductOffering3 = (productOffering3) => {
    setCompanyProducts(prv => {
      return {...prv, productOffering3}
    })
  }

  return (
    <Paper
      component="form"
      onSubmit={(event => {
        event.preventDefault();
        setLoader(true);
        companyProducts.companyId = company.id;
        saveCompanyProducts(companyProducts)
            .then(() => setReload(prv => !prv))
            .then(() => notificationHandler.success('Company Products Saved'))
            .finally(() => setLoader(false))
      })}
      sx={{ mt: 3, p: 3 }}
      elevation={1}
    >
      {companyProducts && (
        <Box>
          {/* Custom Fields */}
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
            Custom Fields
          </Typography>

          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <TextField
                size="small"
                sx={{ flex: 1 }}
                multiline
                minRows={2}
                maxRows={4}
                label="Custom Field 1"
                placeholder="Enter custom field 1 information"
                variant="outlined"
                value={companyProducts.customField1 || ''}
                onChange={(event) => {
                  updateCustomField1(event.target.value);
                }}
            />
            <TextField
                size="small"
                sx={{ flex: 1 }}
                multiline
                minRows={2}
                maxRows={4}
                label="Custom Field 2"
                placeholder="Enter custom field 2 information"
                variant="outlined"
                value={companyProducts.customField2 || ''}
                onChange={(event) => {
                  updateCustomField2(event.target.value);
                }}
            />
            <TextField
                size="small"
                sx={{ flex: 1 }}
                multiline
                minRows={2}
                maxRows={4}
                label="Custom Field 3"
                placeholder="Enter custom field 3 information"
                variant="outlined"
                value={companyProducts.customField3 || ''}
                onChange={(event) => {
                  updateCustomField3(event.target.value);
                }}
            />
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Product Offerings */}
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
            Product Offerings
          </Typography>

          <TextField
              fullWidth
              size="small"
              multiline
              minRows={3}
              maxRows={6}
              label="Product Offering 1"
              placeholder="Describe your first product offering"
              variant="outlined"
              value={companyProducts.productOffering1 || ''}
              onChange={(event) => {
                updateProductOffering1(event.target.value);
              }}
              sx={{ mb: 2 }}
          />

          <TextField
              fullWidth
              size="small"
              multiline
              minRows={3}
              maxRows={6}
              label="Product Offering 2"
              placeholder="Describe your second product offering"
              variant="outlined"
              value={companyProducts.productOffering2 || ''}
              onChange={(event) => {
                updateProductOffering2(event.target.value);
              }}
              sx={{ mb: 2 }}
          />

          <TextField
              fullWidth
              size="small"
              multiline
              minRows={3}
              maxRows={6}
              label="Product Offering 3"
              placeholder="Describe your third product offering"
              variant="outlined"
              value={companyProducts.productOffering3 || ''}
              onChange={(event) => {
                updateProductOffering3(event.target.value);
              }}
              sx={{ mb: 2 }}
          />

          <Divider sx={{ my: 3 }} />

          {/* Actions */}
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      )}
    </Paper>
  );
};

export default CompanyProductTab;
